import { useEffect } from "react";
import useQuery from "../../../hooks/useQuery";
import { browserLocalPersistence, setPersistence, signInWithCustomToken } from "firebase/auth";
import { auth } from "../../../firebase/firebase";
import { useHistory, useLocation } from "react-router-dom";

const SubDomainSignin = () => {
    const query = useQuery();
    const { pathname } = useLocation();
    const setAuthToken = (authToken: string) => {
        localStorage.setItem("authToken", authToken);
        document.cookie = `authToken=${authToken}; path=/; domain=.brainhealthpro.ca; SameSite=None; Secure`;
    };

    useEffect(() => {
        const signin = async () => {
            try {
                const tokenQuery = query.get("token");
                const existingToken = localStorage.getItem("authToken");

                if (tokenQuery && tokenQuery !== existingToken) {
                    await setPersistence(auth, browserLocalPersistence);
                    await signInWithCustomToken(auth, tokenQuery);
                    setAuthToken(tokenQuery);
                    console.log("Signed in with token");
                    window.history.replaceState({}, document.title, window.location.pathname);
                } else {
                    if (
                        window.location.href.includes("sleep-library.brainhealthpro.ca/login") ||
                        window.location.href.includes("test.sleep-library.brainhealthpro.ca/login")
                    ) {
                        window.location.href = "https://brainhealthpro.ca/login";
                    }
                }
            } catch (e) {
                console.error(e);
            }
        };
        signin();
    }, [query, pathname]);

    return <></>;
};

export default SubDomainSignin;
